import { CheckIcon, ExclamationMarkIcon } from '@panwds/icons';
import { getTargetClassName, twMerge } from '@panwds/tailwindcss';
import React, { useContext } from 'react';
import { ADVANCED_VERTICAL_STEPPER_STAGE, ADVANCED_VERTICAL_STEPPER_STATUS } from '../types.js';
import { AdvancedVerticalStepperContext } from './advanced_vertical_stepper.js';
import { getBottomConnectorBorderColor, getConnectorBackgroundColor, getConnectorBorderColor, getTopConnectorBorderColor } from './advanced_vertical_stepper.logic.js';
const getDefaultStatusIcon = (status) => {
    if (status === ADVANCED_VERTICAL_STEPPER_STATUS.COMPLETE) {
        return React.createElement(CheckIcon, { size: "xxs" });
    }
    if (status === ADVANCED_VERTICAL_STEPPER_STATUS.ERROR) {
        return React.createElement(ExclamationMarkIcon, { size: "xxs" });
    }
    return null;
};
export function AdvancedVerticalStepperConnector(props) {
    const { position, currentPosition, className, onClick, isPreviousNonOptionalItemFilled } = props;
    const { items, maxStatusFilledIndex } = useContext(AdvancedVerticalStepperContext);
    const { stage, status, getStatusIcon, headerLabel, optional } = items[position] ?? {};
    return (React.createElement("div", { className: twMerge('twds-flex twds-flex-col twds-min-w-[1.5rem] twds-max-w-[1.5rem] twds-pr-2', stage === ADVANCED_VERTICAL_STEPPER_STAGE.FIRST_STAGE && 'twds-pt-5') },
        stage !== ADVANCED_VERTICAL_STEPPER_STAGE.FIRST_STAGE && (React.createElement("div", { className: "twds-flex twds-justify-center" },
            React.createElement("div", { "data-testid": `step-connector-top-${position}`, className: twMerge('twds-flex twds-border-y-0 twds-border-solid', headerLabel ? 'twds-h-[4.25rem]' : 'twds-h-[1.25rem]', 'twds-border', getTopConnectorBorderColor({
                    currentPosition,
                    position,
                    status,
                    maxStatusFilledIndex
                }), getTargetClassName(className, 'topConnector', { currentPosition, position })) }))),
        React.createElement("div", { className: "twds-flex twds-justify-center" },
            React.createElement("div", { "data-testid": `step-connector-center-${position}`, className: twMerge((position === 0 || currentPosition === position || isPreviousNonOptionalItemFilled || optional) &&
                    'hover:twds-cursor-pointer', 'twds-flex twds-justify-center twds-items-center', !status
                    ? 'twds-min-w-[12px] twds-min-h-[12px] twds-max-w-[12px] twds-max-h-[12px]'
                    : 'twds-min-w-[16px] twds-min-h-[16px] twds-max-w-[16px] twds-max-h-[16px]', 'twds-rounded-full twds-text-primary-dark', (!status || (!status && typeof maxStatusFilledIndex === 'number' && maxStatusFilledIndex > position)) &&
                    'twds-border-solid twds-border-2', getConnectorBackgroundColor({ status, currentPosition, position }), getConnectorBorderColor({ status, currentPosition, position, maxStatusFilledIndex }), getTargetClassName(className, 'icon', { currentPosition, position })), onClick: () => onClick?.({
                    currentPosition,
                    position,
                    isPreviousNonOptionalItemFilled
                }) }, (currentPosition !== position && status && getStatusIcon?.({ currentPosition, position, status })) ??
                getDefaultStatusIcon(status))),
        stage !== ADVANCED_VERTICAL_STEPPER_STAGE.LAST_STAGE && (React.createElement("div", { className: "twds-flex twds-h-full twds-justify-center" },
            React.createElement("div", { "data-testid": `step-connector-bottom-${position}`, className: twMerge('twds-border-solid twds-border twds-h-full', getBottomConnectorBorderColor({
                    currentPosition,
                    position,
                    status,
                    nextItemStatus: items[position + 1]?.status,
                    maxStatusFilledIndex
                }), getTargetClassName(className, 'bottomConnector', {
                    currentPosition,
                    position
                })) })))));
}
//# sourceMappingURL=advanced_vertical_stepper_connector.js.map